<template>
     <div>
    <div class="white-background list-top-margin">
      <!-- 面包屑导航 -->
      <div class="page-top">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>{{menuName.first}}</el-breadcrumb-item>
          <el-breadcrumb-item >
            <span @click="goBack" class="cursor-pointer">{{menuName.second}}</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            <span style="color:#000;font-weight:bold;">{{menuName.three}}</span>
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div style="height:45px">
          <el-button type="primary" size="small" @click="addNewRules">添加新规则</el-button>
      </div>

    <!-- </div>

    <div class="white-background"> -->

        <!--列表-->
        <el-table
          size="small"
          :data="listData"
          highlight-current-row
          v-loading="loading"
          stripe
          border
          :header-cell-style="_headerStyle"
          element-loading-text="加载中"
          style="width: 100%;"
        >
          <el-table-column align="left" type="index" width="50" label="序号"></el-table-column>

          <el-table-column prop="deptNo" label="校验规则" ></el-table-column>
          <el-table-column prop="deptNo" label="错误提示" ></el-table-column>
          <el-table-column prop="deptNo" label="状态" ></el-table-column>

          <el-table-column align="left" label="操作" min-width="190" fixed="right">
            <template slot-scope="scope">
              <el-tooltip content="编辑">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  circle
                  @click="handleEdit(scope.$index, scope.row)"
                ></el-button>
              </el-tooltip>
              <el-tooltip content="打印">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-printer"
                  circle
                  @click="handleEdit(scope.$index, scope.row)"
                ></el-button>
              </el-tooltip>

              <el-tooltip content="删除">
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  @click="deleteUser(scope.$index, scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather" class="tbl-pagination"></Pagination>
      </div>
      <AddRules :diaVisible="diaVisible" @save="save"></AddRules>

  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import AddRules from "@/views/customSetting/order/addRules";
export default {
  name:'validRule',
  components:{
      Pagination,
      AddRules
  },
  props:['menuName'],
  data() {
    return {
      form: {},
      isFold: true,
      listData: [],
      loading: false,
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      diaVisible:false,

    };
  },
  created() {},
  methods: {
    fold() {
      this.isFold = !this.isFold;
    },
    search() {},

     // 分页插件事件
    callFather(parm) {
    },
    /**
     * 返回上一级
     */
    goBack(){
        this.$emit("goBack");
    },
    save(){
        this.diaVisible = false;
    },
    addNewRules(){
        this.diaVisible = true;
    }

  }
}
</script>
<style scoped>
    .page-top {
  height: 30px;
  line-height: 30px;
}
.el-breadcrumb {
  line-height: 15px;
}
.page-row {
  /* background-color: #efefef; */
}
.page-row .el-tabs__nav-wrap::after {
  height: 0px;
}
.page-row .el-tabs__header {
  margin: 0px;
}

.user-search {
  margin-top: 20px;
}

.el-divider__text {
  padding: 0px 0px;
  font-size: 20px;
  cursor: pointer;
}
.tbl-pagination {
  text-align: right;
}
.tbl-btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
}
.tbl-btn .tbl-btn-right {
  text-align: right;
}
.el-divider--horizontal {
  margin: 10px 0px;
}
.el-form-item {
  margin-bottom: 20px;
}
.search-row .half-width {
  width: calc(100% - 132px);
  margin-left: 8px;
}
.search-row .input-number {
  width: calc(50% - 5px);
}
</style>



// WEBPACK FOOTER //
// src/views/customSetting/order/validRule.vue